import React, { Component } from 'react';
import IosSwitch from '../IosSwitch';
import DefaultButton from '../DefaultButton';
import DefaultLoader from '../DefaultLoader';
import ReportHelper from '../../helper/ReportHelper';
import moment from 'moment';
import { FormLabel } from '@material-ui/core';
import Firestore from '../../api/firebase/Firestore';
import SessionHelper from '../../helper/SessionHelper';
import ReportDefaultModalOptions from './ReportDefaultModalOptions';

export default class LessonReport extends Component {

    state = {
        loadingModal: true,
        paramDoc: {},
        studentDocs: [],
        teacherDocs: [],
        courtDocs: [],
        allCategories: true,
        categories: [],
        users: [],
        allUsers: true,
        teachers: [],
        allTeachers: true,
        courts: [],
        allCourts: true,
        showLesson: true,
        showExperimentalLesson: true,
        showPrivateLesson: true,
        start: moment().startOf('day').toDate(),
        end: moment().endOf('day').toDate(),
        output: 'download',
        format: 'pdf',
    }

    async componentDidMount() {

        if (this.props.getDocs && this.props.getDocs.length) {

            for (let index = 0; index < this.props.getDocs.length; index++) {
                
                const getDoc = this.props.getDocs[index];
                await getDoc(this, 'studentDocs', true);
            }
        }

        this.setState({ loadingModal: false });
    }

    async getReportDocs() {

        let docs = [];
        let allEvents = [];

        let teachers = this.state.allTeachers ? this.state.teacherDocs : this.state.teachers;
        let teacherDocs = [];

        let users = this.state.allUsers ? this.state.studentDocs : this.state.users;
        let userDocs = [];

        let courts = this.state.allCourts ? this.state.courtDocs : this.state.courts;
        let courtDocs = [];

        let categories = this.state.allCategories ? this.state.paramDoc.categories : this.state.categories;
        let categoryDocs = [];

        teachers.forEach((teacher, key) => {

            let teacherDoc = teacher;

            if (!this.state.allTeachers) {

                teacherDoc = this.state.teacherDocs.find(item => item.id === teacher);
            }

            teacherDocs.push(teacherDoc);
        });

        users.forEach((user, key) => {

            let userDoc = user;

            if (!this.state.allUsers) {

                userDoc = this.state.studentDocs.find(item => item.id === user);
            }

            userDocs.push(userDoc);
        });

        courts.forEach((court, key) => {

            let courtDoc = court;

            if (!this.state.allCourts) {

                courtDoc = this.state.courtDocs.find(item => item.id === court);
            }

            courtDocs.push(courtDoc);
        });

        categories.forEach((category, key) => {

            let categoryDoc = category;

            if (!this.state.allCategories) {

                categoryDoc = this.state.paramDoc.categories.find(item => item.value === category);
            }

            categoryDocs.push(categoryDoc);
        });

        if (this.state.showLesson) {

            let query = await Firestore.customQuery('lesson').where('id_company', '==', SessionHelper.getData().id_company).where('start', '>=', this.state.start).where('start', '<=', this.state.end).get();
            
            allEvents.push({
                type: 'Aula',
                events: query.docs,
            });
        }

        if (this.state.showExperimentalLesson) {

            let query = await Firestore.customQuery('experimental_lesson').where('id_company', '==', SessionHelper.getData().id_company).where('start', '>=', this.state.start).where('start', '<=', this.state.end).get();
            
            allEvents.push({
                type: 'Aula Experimental',
                events: query.docs,
            });
        }

        if (this.state.showPrivateLesson) {

            let query = await Firestore.customQuery('private_lesson').where('id_company', '==', SessionHelper.getData().id_company).where('start', '>=', this.state.start).where('start', '<=', this.state.end).get();
            
            allEvents.push({
                type: 'Aula Avulsa',
                events: query.docs,
            });
        }

        for (let eventType of allEvents) {
         
            let type = eventType.type;
            let events = eventType.events;

            for (let doc of events) {

                let findTeacher = false;
                let findStudent = false;
                let findCourt = false;
                let findCategory = false;

                let event = { ...doc.data(), id: doc.id };
            
                let userNames = [];
                let idUsers = [];
    
                if (event.id_students) { idUsers = event.id_students };
                if (event.id_user) { idUsers = [ event.id_user ] };

                idUsers.forEach((user, key) => {
    
                    let doc = userDocs.find(item => item.id === user);

                    if (doc) {
                        
                        userNames.push(ReportHelper.treatName(doc.name));
                        findStudent = true;
                    }
                });

                if (event.manual_info && event.manual_info.name) { userNames.push(ReportHelper.treatName(event.manual_info.name)) };
    
                let courtNames = [];
                let idCourts = [];

                if (event.id_courts) { idCourts = event.id_courts };
                if (event.id_court) { idCourts = [ event.id_court ] };

                idCourts.forEach((court, key) => {
    
                    let doc = courtDocs.find(item => item.id === court);
                    
                    if (doc) {

                        courtNames.push(doc.name)
                        findCourt = true;

                    } else {

                        userNames.push('Quadra Desconhecida');
                    }
                });

                let order = 'Sem Pedido';

                if (event.id_order) {

                    let query = await Firestore.getDoc('order', event.id_order);
                    if (query.exists) { order = query.data().title };
                }

                let teacher = 'Sem Professor';

                if (event.id_teacher) {

                    let doc = teacherDocs.find(item => item.id === event.id_teacher);

                    if (doc) {
                        
                        teacher = ReportHelper.treatName(doc.name);
                        findTeacher = true;
                    }
                }

                let categoryNames = [];
                let idCategories = event.categories;

                if (idCategories && idCategories.length) {

                    idCategories.forEach((category, key) => {
    
                        let doc = categoryDocs.find(item => item.value === category);
                        
                        if (doc) {
    
                            categoryNames.push(doc.label)
                            findCategory = true;
    
                        } else {
    
                            userNames.push('Quadra Desconhecida');
                        }
                    });
                }

                if (findCourt && (event.id_teacher && findTeacher || !event.id_teacher && this.state.allTeachers) && findStudent && (event.categories && findCategory || !event.categories && this.state.allCategories) ) {

                    docs.push({
                        date: `${moment(event.start.toDate()).format('DD/MM/YY HH:mm')} ~ ${moment(event.end.toDate()).format('HH:mm')}`,
                        court: courtNames.join(', '),
                        students: userNames.join(', '),
                        type: type,
                        order: order,
                        teacher: teacher,
                        categories: categoryNames.join(', '),
                    });
                }
            }
        }

        docs.sort((a, b) => {

            return a.date > b.date;
        });

        return docs;
    }

    async print() {

        this.setState({ loadingModal: true });

        let docs = await this.getReportDocs();
        let name = `Aulas Agendadas - ${SessionHelper.getData().company.name}`;
        let subtitle = `De ${moment(this.state.start).format('DD/MM/YYYY HH:mm')} Até ${moment(this.state.end).format('DD/MM/YYYY HH:mm')}`;
        let report = await ReportHelper.createReport(name, 5, subtitle);

        report = await ReportHelper.createColumns(report, docs, [
            { name: 'Tipo', width: 13, getText: (doc) => doc.type },
            { name: 'Data', width: 45, getText: (doc) => doc.date },
            { name: 'Quadra', width: 85, getText: (doc) => doc.court },
            { name: 'Alunos', width: 128, getText: (doc) => doc.students },
        ]);

        ReportHelper.print(report, this.state.output, this.state.format);

        this.setState({ loadingModal: false });
    }

    renderLoading() {

        return (

            <div style={{ height: 200 }}>
                <DefaultLoader/>
            </div>
        )
    }

    renderModal() {

        return (

            <div>
                <IosSwitch fullWidth label={'Todos os Professores'} checked={this.state.allTeachers} onChange={(e) => { this.setState({ allTeachers: e, teachers: [] }) }} />
                { !this.state.allTeachers ? ReportHelper.renderTeacherSelection(this, this.state.teacherDocs, 'teachers') : null }

                <IosSwitch fullWidth label={'Todos os Alunos'} checked={this.state.allUsers} onChange={(e) => { this.setState({ allUsers: e, users: [] }) }} />
                { !this.state.allUsers ? ReportHelper.renderUserSelection(this, this.state.studentDocs, 'users') : null }

                <IosSwitch fullWidth label={'Todas as Quadras'} checked={this.state.allCourts} onChange={(e) => { this.setState({ allCourts: e, courts: [] }) }} />
                { !this.state.allCourts ? ReportHelper.renderCourtSelection(this, this.state.courtDocs, 'courts') : null }

                <IosSwitch fullWidth label={'Todas as Categorias'} checked={this.state.allCategories} onChange={(e) => { this.setState({ allCategories: e, categories: [] }) }} />
                { !this.state.allCategories ? ReportHelper.renderCategorySelectiony(this, this.state.paramDoc.categories, 'categories') : null }

                { ReportHelper.renderPeriodSelection(this, 'start', 'end', 'dd/MM/yyyy HH:mm') }
                
                <FormLabel style={{ marginTop: 18, fontWeight: '800', marginBottom: 10 }} component="legend">Exibir</FormLabel>
                <IosSwitch fullWidth label={'Aulas'} checked={this.state.showLesson} onChange={(e) => { this.setState({ showLesson: e }) }} />
                <IosSwitch fullWidth label={'Aula Experimental'} checked={this.state.showExperimentalLesson} onChange={(e) => { this.setState({ showExperimentalLesson: e }) }} />
                <IosSwitch fullWidth label={'Aula Avulsa'} checked={this.state.showPrivateLesson} onChange={(e) => { this.setState({ showPrivateLesson: e }) }} />
                <ReportDefaultModalOptions onOutputChange={(value) => { this.setState({ output: value }) }} onFormatChange={(value) => { this.setState({ output: value }) }}/>
                <div style={{alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 50}}>
                    <DefaultButton width={'100%'} title={'Imprimir'} onClick={() => { this.print() }} />
                </div>
            </div>
        )
    }

    render() {

        return (

            this.state.loadingModal ? this.renderLoading() : this.renderModal()
        )
    }
}